(() => {
  const SELECTORS = {
    viewport: '[data-use-cases-viewport]',
    grid: '[data-use-cases-grid]',
    prev: '[data-use-cases-prev]',
    next: '[data-use-cases-next]'
  };

  function getStepSize(viewport) {
    return Math.max(240, Math.floor(viewport.clientWidth * 0.85));
  }

  function updateNavState(viewport, prevBtn, nextBtn) {
    if (!viewport || !prevBtn || !nextBtn) return;

    const maxScroll = viewport.scrollWidth - viewport.clientWidth;
    prevBtn.disabled = viewport.scrollLeft <= 4;
    nextBtn.disabled = viewport.scrollLeft >= maxScroll - 4;
  }

  function initSection(section) {
    const viewport = section.querySelector(SELECTORS.viewport);
    const grid = section.querySelector(SELECTORS.grid);
    const prevBtn = section.querySelector(SELECTORS.prev);
    const nextBtn = section.querySelector(SELECTORS.next);

    if (!viewport || !grid || !prevBtn || !nextBtn) return;

    const onPrev = () => {
      viewport.scrollBy({ left: -getStepSize(viewport), behavior: 'smooth' });
    };

    const onNext = () => {
      viewport.scrollBy({ left: getStepSize(viewport), behavior: 'smooth' });
    };

    prevBtn.addEventListener('click', onPrev);
    nextBtn.addEventListener('click', onNext);

    viewport.addEventListener('scroll', () => {
      updateNavState(viewport, prevBtn, nextBtn);
    }, { passive: true });

    window.addEventListener('resize', () => {
      updateNavState(viewport, prevBtn, nextBtn);
    });

    updateNavState(viewport, prevBtn, nextBtn);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.use-cases');
    sections.forEach((section) => initSection(section));
  });
})();
